// extracted by mini-css-extract-plugin
export default {"resultsContainer":"SearchResults_resultsContainer__siarA","list":"SearchResults_list__atohg"};